/** Shared imagery & catalog for Estore marketing pages */

export const brand = {
  name: "EStore",
  tagline: "Curated essentials • fast delivery",
  accent: "#6366F1",
  accent2: "#0EA5E9",
  bg: "#F8FAFC",
  text: "#0F172A",
  muted: "rgba(15, 23, 42, 0.65)",
  stroke: "rgba(15, 23, 42, 0.08)",
};

export const heroSlides = [
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1600&h=720&fit=crop&q=80",
    title: "Spring collection",
    subtitle: "Soft layers, clean lines, everyday polish.",
  },
  {
    id: 2,
    src: "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=1600&h=720&fit=crop&q=80",
    title: "Home & living",
    subtitle: "Light, texture, and calm for your space.",
  },
  {
    id: 3,
    src: "https://images.unsplash.com/photo-1498049794561-7780e7231661?w=1600&h=720&fit=crop&q=80",
    title: "Tech & audio",
    subtitle: "Gear that keeps up with your rhythm.",
  },
  {
    id: 4,
    src: "https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=1600&h=720&fit=crop&q=80",
    title: "Style edit",
    subtitle: "Statement pieces without the noise.",
  },
  {
    id: 5,
    src: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=1600&h=720&fit=crop&q=80",
    title: "Move & train",
    subtitle: "Performance fabrics, refined fit.",
  },
  {
    id: 6,
    src: "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=1600&h=720&fit=crop&q=80",
    title: "Beauty & care",
    subtitle: "Minimal routines, visible results.",
  },
];

export const categories = [
  {
    name: "Men",
    image:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=480&fit=crop&q=80",
    hint: "Shirts • Knits • Denim",
  },
  {
    name: "Women",
    image:
      "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=600&h=480&fit=crop&q=80",
    hint: "Dresses • Knitwear • Shoes",
  },
  {
    name: "Electronics",
    image:
      "https://images.unsplash.com/photo-1498049794561-7780e7231661?w=600&h=480&fit=crop&q=80",
    hint: "Audio • Wearables • Desk",
  },
  {
    name: "Accessories",
    image:
      "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=600&h=480&fit=crop&q=80",
    hint: "Bags • Watches • Eyewear",
  },
  {
    name: "Home",
    image:
      "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&h=480&fit=crop&q=80",
    hint: "Lighting • Textiles • Decor",
  },
  {
    name: "Sports",
    image:
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=480&fit=crop&q=80",
    hint: "Run • Train • Recover",
  },
  {
    name: "Beauty",
    image:
      "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=600&h=480&fit=crop&q=80",
    hint: "Skin • Hair • Fragrance",
  },
  {
    name: "Kids",
    image:
      "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=600&h=480&fit=crop&q=80",
    hint: "Play • School • Comfort",
  },
];

export const categoryMenu = [
  {
    label: "Fashion",
    items: ["Men", "Women", "Kids", "Accessories"],
  },
  {
    label: "Lifestyle",
    items: ["Home", "Sports", "Beauty"],
  },
  {
    label: "Tech",
    items: ["Electronics"],
  },
];

export { featuredProducts, searchCatalog } from "./estoreCatalog";

export const promoBanner = {
  image:
    "https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=1600&h=560&fit=crop&q=80",
  title: "Members save on every order",
  subtitle: "Join for early access to drops, free returns, and curated edits.",
  cta: "Explore membership",
};
